export default __webpack_public_path__ + "static/media/mati.8862d712.png";